module.exports = __webpack_public_path__ + "static/initial-phone-rotated-6a4fae1fff4bea6882100d1e9f4a4f1e.png";